import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';
import type { TooltipContentMessageFlags } from './types.tsx';

export type Props = {
	readonly isAppField: boolean;
	readonly fieldCreator: string;
} & TooltipContentMessageFlags;

export const FieldTooltipContent = ({
	isAppField,
	fieldCreator,
	uneditable,
	unrequirable,
	unsortable,
	unremovable,
}: Props) => {
	const intl = useIntl();
	const baseMessage = isAppField ? messages.baseAppField : messages.base;

	return (
		<>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<p>{intl.formatMessage(baseMessage, { fieldCreator })}</p>
			<ContentList>
				{uneditable && <li key="edit">{intl.formatMessage(messages.edit)}</li>}
				{unrequirable && <li key="require">{intl.formatMessage(messages.require)}</li>}
				{unremovable && <li key="remove">{intl.formatMessage(messages.remove)}</li>}
				{unsortable && <li key="sort">{intl.formatMessage(messages.sort)}</li>}
			</ContentList>
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentList = styled.ul<{
	children?: ReactNode;
}>({
	listStyle: 'inside',
	marginTop: token('space.100'),
	paddingLeft: token('space.050'),
	paddingBottom: token('space.050'),
});
